(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('DeleteTagController', DeleteTagController);

    DeleteTagController.$inject = ['$state', '$uibModalInstance', 'TestSettingTag', 'AlertService', 'entity'];

    function DeleteTagController($state, $uibModalInstance, TestSettingTag, AlertService, entity) {
        var vm = this;

        if(entity.$promise) {
            entity.$promise.then(function () {
                vm.tag = entity;
            });
        }

        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        vm.confirmDelete = function (id) {
            TestSettingTag.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        };

    }
})();
